import React from 'react';

function LogoWhite(props) {
  return <img alt="Logo" src="/static/pt_logo_white.svg" {...props} />;
}

export default LogoWhite;
